module.exports = __webpack_public_path__ + "img/career-1.9341fc1e.jpg";